import {decorate, computed} from 'mobx';

import {BaseFlowStore} from "../base-flow-store";

/**
 * DigitalCreditAppFlowStore extends the BaseFlowStore which contains common functionality shared between flows
 */
export class DigitalCreditAppFlowStore extends BaseFlowStore {

    get hasCompletedDigitalCreditAppForm () {
        return !!this.applicationUuid;
    }

    /**
     * Redirects to the next step in the flow
     *
     *  - flowStepName: the name of the step to redirect to
     */
    handleStepRedirection = (flowStepName) => {
        let destinationUrl;
        switch (flowStepName) {
            case "coapplicant":
                this.historyStore.history.push(this.getPrequalUrl("/coapplicant") + `?flowUuid=${this.applicationUuid}`);
                return;

            case "decisioning":
                if (this.isCoapplicantFlow) {
                    destinationUrl = this.getPrequalUrl(`/offers/${this.applicationUuid}/${this.primaryApplicantUuid}`);
                    this.historyStore.history.push(destinationUrl);
                }
                else {
                    destinationUrl = this.getPrequalUrl(`/offers/${this.applicationUuid}`);
                    this.historyStore.history.push(destinationUrl);
                }
                return;

            default:
                const metadata = {
                    flowStepName,
                    applicationUuid: this.applicationUuid,
                    primaryApplicantUuid: this.primaryApplicantUuid,
                }
                console.error(`Unknown flow step name: ${flowStepName}, has to be implemented in handleStepRedirection`, metadata);
        }
    }

}

decorate(DigitalCreditAppFlowStore, {
    hasCompletedDigitalCreditAppForm: computed,
});
